<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="data.so_uuid">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex justify-content-between align-items-start mb-4">
              <div>
                <h5 class="font-size-16 mb-1">{{ data.so_no }}</h5>
                <p class="text-muted mb-1">Tanggal: {{ data.so_date }}</p>
                <p class="text-muted mb-0" v-if="data.so_notes">{{ data.so_notes }}</p>
              </div>
              <div class="d-flex align-items-center" style="gap:8px">
                <span :class="data.so_status == 1 ? 'badge badge-success badge-pill font-size-13' : 'badge badge-warning badge-pill font-size-13'">
                  {{ data.so_status == 1 ? 'Confirmed' : 'Draft' }}
                </span>
                <router-link v-if="data.so_status == 0" :to="{ name: 'stock_opname_edit', params: { uuid } }" class="btn btn-sm btn-info">
                  <i class="mdi mdi-pencil mr-1"></i>Edit
                </router-link>
                <button v-if="data.so_status == 0" class="btn btn-sm btn-success" @click="confirmOpname" :disabled="confirming">
                  <i class="mdi mdi-check-circle mr-1"></i>
                  {{ confirming ? "Memproses..." : "Konfirmasi" }}
                </button>
                <button v-if="data.so_status == 0" class="btn btn-sm btn-danger" @click="deleteOpname">
                  <i class="mdi mdi-trash-can-outline mr-1"></i>Hapus
                </button>
                <router-link :to="{ name: table_module }" class="btn btn-sm btn-secondary">
                  <i class="mdi mdi-arrow-left mr-1"></i>Kembali
                </router-link>
              </div>
            </div>

            <div class="alert alert-warning d-flex align-items-center" v-if="data.so_status == 0">
              <i class="mdi mdi-information-outline mr-2 font-size-16"></i>
              <span>Status masih <strong>Draft</strong>. Klik <strong>Konfirmasi</strong> untuk memperbarui stok produk sesuai hasil opname.</span>
            </div>
            <div class="alert alert-success d-flex align-items-center" v-else>
              <i class="mdi mdi-check-circle-outline mr-2 font-size-16"></i>
              <span>Opname sudah <strong>dikonfirmasi</strong>. Stok produk telah diperbarui.</span>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead class="thead-light">
                  <tr>
                    <th>Produk</th>
                    <th>SKU</th>
                    <th class="text-center">Stok Sistem</th>
                    <th class="text-center">Stok Aktual</th>
                    <th class="text-center">Selisih</th>
                    <th>Catatan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!data.items || data.items.length === 0">
                    <td colspan="6" class="text-center text-muted py-3">Tidak ada produk</td>
                  </tr>
                  <tr v-for="(item, i) in data.items" :key="i">
                    <td>{{ item.prd_name }}</td>
                    <td class="text-muted small">{{ item.prd_sku || '-' }}</td>
                    <td class="text-center">{{ item.sod_stock_system }}</td>
                    <td class="text-center font-weight-bold">{{ item.sod_stock_actual }}</td>
                    <td class="text-center">
                      <span :class="selisihClass(item.sod_selisih)">
                        {{ item.sod_selisih >= 0 ? '+' : '' }}{{ item.sod_selisih }}
                      </span>
                    </td>
                    <td class="text-muted small">{{ item.sod_notes || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row mt-3" v-if="data.items && data.items.length > 0">
              <div class="col-md-4 ml-auto">
                <table class="table table-sm table-bordered">
                  <tr>
                    <td>Total Produk</td>
                    <td class="text-right font-weight-bold">{{ data.items.length }}</td>
                  </tr>
                  <tr>
                    <td class="text-success">Selisih Masuk (+)</td>
                    <td class="text-right text-success font-weight-bold">{{ totalMasuk }}</td>
                  </tr>
                  <tr>
                    <td class="text-danger">Selisih Keluar (-)</td>
                    <td class="text-right text-danger font-weight-bold">{{ totalKeluar }}</td>
                  </tr>
                  <tr>
                    <td>Tidak Ada Selisih</td>
                    <td class="text-right text-muted">{{ totalSama }}</td>
                  </tr>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      confirming: false,
      module: "Stock Opname",
      table_module: "stock_opname",
      uuid: this.$route.params.uuid,
      data: {},
    };
  },
  computed: {
    totalMasuk()  { return (this.data.items || []).filter((i) => i.sod_selisih > 0).length; },
    totalKeluar() { return (this.data.items || []).filter((i) => i.sod_selisih < 0).length; },
    totalSama()   { return (this.data.items || []).filter((i) => i.sod_selisih === 0 || i.sod_selisih == 0).length; },
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios.get("/" + this.table_module + "/detail/" + this.uuid).then((res) => {
        this.data = res.data.data;
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
        this.$toast.error("Data tidak ditemukan");
        this.$router.push({ name: this.table_module });
      });
    },
    selisihClass(val) {
      const n = parseInt(val);
      if (n > 0) return "text-success font-weight-bold";
      if (n < 0) return "text-danger font-weight-bold";
      return "text-muted";
    },
    confirmOpname() {
      if (!confirm("Konfirmasi opname? Stok produk akan diperbarui sesuai hasil opname dan tidak bisa diubah lagi.")) return;
      this.confirming = true;
      this.axios.post("/" + this.table_module + "/confirm/" + this.uuid)
        .then((res) => {
          this.confirming = false;
          this.$toast.success(res.data.message || "Berhasil dikonfirmasi");
          this.fetchDetail();
        })
        .catch(() => { this.confirming = false; this.$toast.error("Gagal konfirmasi"); });
    },
    deleteOpname() {
      if (!confirm("Yakin ingin menghapus opname ini?")) return;
      this.isLoading = true;
      this.axios.post("/" + this.table_module + "/delete/" + this.uuid)
        .then((res) => {
          this.isLoading = false;
          this.$toast.success(res.data.message || "Berhasil dihapus");
          this.$router.push({ name: this.table_module });
        })
        .catch(() => { this.isLoading = false; this.$toast.error("Gagal menghapus"); });
    },
  },
};
</script>
